import script from "./CreditCalculatorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditCalculatorPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__